import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { FormFolder } from 'src/app/core/models/physician/form-folder';
import { FormServiceResolver } from 'src/app/core/services/v2/form.service';
import { PracticeService } from 'src/app/core/services/v2/practice.service';
import { FormEditFolderComponent } from 'src/app/physician/formdocs/form-edit-folder/form-edit-folder.component';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';

@Component({
  selector: 'app-manage-template-forms',
  templateUrl: './manage-template-forms.component.html',
  styleUrls: ['./manage-template-forms.component.scss']
})
export class ManageTemplateFormsComponent implements OnInit {


  activeFormFolders: FormFolder[];
  templateFormFolders: FormFolder[];
  toggleSidebar = false;
  sectionName: string;
  sideBarHeader: string;
  oldText: string;

  @ViewChild('formsSearchInput', { static: true }) formsSearchInput: ElementRef;
  @ViewChild(FormEditFolderComponent, { static: false }) childComponent: FormEditFolderComponent;

  constructor(private practiceService: PracticeService,
    
    private loaderService: WindowLoaderService,
    private _router: Router,
    private dialog: MatDialog,
    private formServiceResolver: FormServiceResolver
  ) {
    // this.formService.formServiceSetup();

  }

  ngOnInit() {
    fromEvent(this.formsSearchInput.nativeElement, 'keyup').pipe(
      map((event: any) => {
        return event.target.value;
      })
      , debounceTime(500)
      , distinctUntilChanged()
    ).subscribe((text: string) => {
      if ((this.oldText && this.oldText.length > 0) || (text && text.length > 0)) {
        this.searchForms(text);
        this.oldText = text;
      }
    });
  }

  ngAfterViewInit() {
    this.searchForms('');
  }
  searchForms(searchTerm: string) {

    this.loaderService.show();
    this.formServiceResolver.getFormService().subscribe(
      (fSvc) => {
        fSvc.getFormsDocs(searchTerm).subscribe(
          (result) => {
            this.activeFormFolders = result.result;
          },
          (error) => { console.error(error); },
          () => { this.loaderService.hide(); }
        );
      }

    );
  }


  showHideScroll(isOpen: boolean) {
    /* To stop body scroll while sidebar is Open */
    const body = document.querySelector('body');
    if (isOpen) {
      body.style.cssText = 'height:100vh; overflow:hidden';
    } else {
      body.style.cssText = 'height:auto; overflow:visible';
    }
  }
  toggleEditSidebar(sectionName: string) {
    this.sectionName = sectionName;
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    //this.destroyChild();
  }
  togglePopUp(formFolders: FormFolder[]) {
    this.activeFormFolders = formFolders ? formFolders : [];
    this.toggleSidebar = !this.toggleSidebar;
    this.showHideScroll(this.toggleSidebar);
    //this.destroyChild();
  }


  add() {

    this.formServiceResolver.getFormDetailsRoute().subscribe( (spaFormDetailsRoute) => this._router.navigate([`${spaFormDetailsRoute}0`])   );
    ;
  }

}
